<template lang="pug">
.waiter-progress-histories-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：日時
    template(#cell(datetime)="row")
      span {{ convertDate(row.item.datetime) }}
      span （
      span(:class="getWeekClass(convertWeek(row.item.datetime))") {{ convertWeek(row.item.datetime) }}
      span ）
      span {{ convertTime(row.item.datetime) }}
    // セル：タイトル
    template(#cell(title)="row")
      .progress-history-icon(v-if="row.item.historyType == 1")
      .update-history-icon(v-if="row.item.historyType == 2")
      span {{ getTitle(row.item) }}
    // セル：内容
    template(#cell(text)="row")
      // title and text histroy
      template(v-if="row.item.columnType == 'text'")
        .mr-2(v-if="row.item.showAllText == false")
          .short-text {{ getText(row.item) }}
        .mr-2(v-else)
          .all-text {{ getText(row.item) }}
      // status history
      template(v-if="row.item.columnType == 'status'")
        .history(v-for="history in ")
          span.font-weight-bold.mr-1 {{ convertStatusName(row.item.beforeStatus) }}
          span.mr-1 から
          span.font-weight-bold {{ convertStatusName(row.item.afterStatus) }}
      // change history
      template(v-if="row.item.columnType == 'history'")
        .mr-2(v-if="row.item.showAllText == false")
          .short-text
            .normal-history(v-if="isNormalHistory(row.item.updateHistories[0])")
              span.font-weight-bold {{ row.item.updateHistories[0].columnName }}：
              span 「
              span(:class="row.item.updateHistories[0].beforeClass") {{ row.item.updateHistories[0].beforeValue }}
              span 」から「
              span(:class="row.item.updateHistories[0].afterClass") {{ row.item.updateHistories[0].afterValue }}
              span 」
            .checkbox-history(v-if="isCheckboxHistory(row.item.updateHistories[0])")
              span.font-weight-bold {{ row.item.updateHistories[0].columnName }}：
              img.checkbox(v-if="row.item.updateHistories[0].beforeValue == null" src="@/assets/login-checkbox-off.png")
              img.checkbox(v-if="row.item.updateHistories[0].beforeValue == false" src="@/assets/login-checkbox-off.png")
              img.checkbox.mr-1(v-if="row.item.updateHistories[0].beforeValue == true" src="@/assets/login-checkbox-on.png")
              span.mr-1 から
              img.checkbox(v-if="row.item.updateHistories[0].afterValue == null" src="@/assets/login-checkbox-off.png")
              img.checkbox(v-if="row.item.updateHistories[0].afterValue == false" src="@/assets/login-checkbox-off.png")
              img.checkbox(v-if="row.item.updateHistories[0].afterValue == true" src="@/assets/login-checkbox-on.png")
            .array-history(v-if="isArrayHistory(row.item.updateHistories[0])")
              span.font-weight-bold {{ row.item.updateHistories[0].columnName }}：
              span 「
              span(v-for="(value, index) in row.item.updateHistories[0].beforeValue" :class="row.item.updateHistories[0].beforeClass[index]").mr-1 {{ value }}
              span 」から「
              span(v-for="(value, index) in row.item.updateHistories[0].afterValue" :class="row.item.updateHistories[0].afterClass[index]").mr-1 {{ value }}
              span 」
            .room-type-history(v-if="isRoomTypeHistory(row.item.updateHistories[0])")
              span.font-weight-bold {{ row.item.updateHistories[0].columnName }}：
              span(:class="row.item.updateHistories[0].afterClass") {{ row.item.updateHistories[0].afterValue }}
          
        .mr-2(v-else)
          .history(v-for="history in row.item.updateHistories")
            .normal-history(v-if="isNormalHistory(history)")
              span.font-weight-bold {{ history.columnName }}：
              span 「
              span(:class="history.beforeClass") {{ history.beforeValue }}
              span 」から「
              span(:class="history.afterClass") {{ history.afterValue }}
              span 」
            .checkbox-history(v-if="isCheckboxHistory(history)")
              span.font-weight-bold {{ history.columnName }}：
              img.checkbox(v-if="history.beforeValue == null" src="@/assets/login-checkbox-off.png")
              img.checkbox(v-if="history.beforeValue == false" src="@/assets/login-checkbox-off.png")
              img.checkbox.mr-1(v-if="history.beforeValue == true" src="@/assets/login-checkbox-on.png")
              span.mr-1 から
              img.checkbox(v-if="history.afterValue == null" src="@/assets/login-checkbox-off.png")
              img.checkbox(v-if="history.afterValue == false" src="@/assets/login-checkbox-off.png")
              img.checkbox(v-if="history.afterValue == true" src="@/assets/login-checkbox-on.png")
            .array-history(v-if="isArrayHistory(history)")
              span.font-weight-bold {{ history.columnName }}：
              span 「
              span(v-for="(value, index) in history.beforeValue" :class="history.beforeClass[index]").mr-1 {{ value }}
              span 」から「
              span(v-for="(value, index) in history.afterValue" :class="history.afterClass[index]").mr-1 {{ value }}
              span 」
            .room-type-history(v-if="isRoomTypeHistory(history)")
              span.font-weight-bold {{ history.columnName }}：
              span(:class="history.afterClass") {{ history.afterValue }}

      .text-controll(v-if="row.item.columnType == 'text' || row.item.columnType == 'history'")
        .mb-1
        .open-all.d-flex.justify-content-end(v-if="row.item.showAllText == false")
          span(@click="row.item.showAllText = !row.item.showAllText") 全て表示
        .close-all.d-flex.justify-content-end(v-if="row.item.showAllText == true")
          span(@click="row.item.showAllText = !row.item.showAllText") 閉じる
    // セル：操作
    template(#cell(operation)="row")
      button.btn.edit-btn.mr-2(@click="onEdit(row.item)" type="button"
        :disabled="isDisableButton(row.item)" :class="{ disable: isDisableButton(row.item) }") 修正
      button.btn.delete-btn(@click="onDelete(row.item)" type="button"
        :disabled="isDisableButton(row.item)" :class="{ disable: isDisableButton(row.item) }") 削除
    // セル：更新者／記載者
    template(#cell(writer)="row")
      span {{ getWriter(row.item) }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { HistoryType, WaiterProgressHistoriesGetModel, WriterType } from "@/commons/services/WaiterProgressHistories";
import { FacilityGetModel } from "@/commons/services/Facilities";
import { userStore } from "@/store/store";
import { ResidentStatus } from "@/commons/services/Residents";
import { TemplateType } from "@/commons/services/AdmissionApplicationTemplates";

/**
 * ### 待機者経過記録テーブルコンポーネント
 */
@Component({})
export default class WaiterProgressHistoriesTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<WaiterProgressHistoriesTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<WaiterProgressHistoriesTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  @Prop()
  waiterViewableFacilitiesMap!: Map<number, FacilityGetModel>;

  get _value(): Array<WaiterProgressHistoriesTableItem> {
    return this.value;
  }

  /**
   * ### 日時を「yyyy年mm月dd日」形式に変換する
   */
  public convertDate(datetime: number): string {
    const date: string = this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日");
    return date;
  }

  /**
   * ### 日時から曜日文字列に変換する
   */
  public convertWeek(datetime: number): string {
    const week: string = this.$dateUtil.getWeekName(this.$dateUtil.convertNumberToDate(datetime), "ja");
    return week;
  }

  /**
   * ### 曜日に応じたCSSクラスを取得する
   */
  public getWeekClass(week: string): string {
    switch (week) {
      case "日": {
        return "sunday";
      }
      case "土": {
        return "saturday";
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 日時を「hh：MM」形式に変換する
   */
  public convertTime(datetime: number): string {
    const time: string = this.$dateUtil.convertNumberToString(datetime, "hh：MM");
    return time;
  }

  public getTitle(item: WaiterProgressHistoriesTableItem): string {
    return item.title;
  }

  public getText(item: WaiterProgressHistoriesTableItem): string {
    if (item.text != null) {
      return item.text;
    }
    return "";
  }

  public convertStatusName(status: ResidentStatus): string {
    let statusName: string = "";

    switch (status) {
      case ResidentStatus.REGISTERD:
        statusName = "登録者";
        break;
      case ResidentStatus.CANCELED:
        statusName = "取り下げ";
        break;
      case ResidentStatus.TEMPORARILY:
        statusName = "一時保存";
        break;
      case ResidentStatus.APPLICATION:
        statusName = "入所申込み";
        break;
      case ResidentStatus.RECEIVED_APPLICATION:
        statusName = "申込み受理";
        break;
      case ResidentStatus.COMPLETE_APPLICATION:
        statusName = "判定済";
        break;
      case ResidentStatus.CONFIRM_ADMISSION:
        statusName = "入所意向確認";
        break;
      case ResidentStatus.FINAL_JUDGE:
        statusName = "最終判定中";
        break;
      case ResidentStatus.COMPLETE_FINAL_JUDGE:
        statusName = "最終判定済";
        break;
      case ResidentStatus.ADMISSION_PROCEDURE:
        statusName = "入所手続き";
        break;
      case ResidentStatus.RESIDENT:
        statusName = "利用者";
        break;
      default:
        statusName = "";
        break;
    }

    return statusName;
  }

  public isNormalHistory(history: UpdateHistory): boolean {
    if (!history) {
      return false;
    }
    switch (history.type) {
      case TemplateType.TEXT:
      case TemplateType.RADIO:
      case TemplateType.SELECT:
      case TemplateType.TEXTAREA:
      case TemplateType.FILE:
      case TemplateType.TEL:
      case TemplateType.NAME: {
        return true;
      }
      // チェックボックスだが、CSV出力と同じく文字列連結で表現するので通常履歴として扱う
      case TemplateType.MULTIPLE_CHECKBOX: {
        return true;
      }
      default: {
        return false;
      }
    }
  }

  public isCheckboxHistory(history: UpdateHistory): boolean {
    if (!history) {
      return false;
    }
    switch (history.type) {
      case TemplateType.CHECKBOX:
      case TemplateType.SWITCH_CHECKBOX: {
        return true;
      }
      default: {
        return false;
      }
    }
  }

  public isArrayHistory(history: UpdateHistory): boolean {
    if (!history) {
      return false;
    }
    switch (history.type) {
      case TemplateType.ADDRESS:
      case TemplateType.BIRTHDAY:
      case TemplateType.YEAR_MONTH_DATE:
      case TemplateType.YEAR_MONTH: {
        return true;
      }
      default: {
        return false;
      }
    }
  }

  public isRoomTypeHistory(history: UpdateHistory): boolean {
    if (!history) {
      return false;
    }
    switch (history.type) {
      case TemplateType.ROOM_TYPE: {
        return true;
      }
      default: {
        return false;
      }
    }
  }

  /**
   * ### 記載者を取得する
   */
  public getWriter(item: WaiterProgressHistoriesTableItem): string {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(item.facilityId);
    if (facility == undefined) {
      return "";
    }

    if (item.writerType == WriterType.FACILITY_USER) {
      if (item.facilityId == userStore.loginUser.facilityId) {
        return `${facility.name}（${item.writerName}）`;
      } else {
        return `${facility.name}`;
      }
    } else if (item.writerType == WriterType.WAITER) {
      return `${item.writerName}`;
    }

    return "";
  }

  /**
   * ### 修正・削除の非活性化可否
   */
  public isDisableButton(item: WaiterProgressHistoriesTableItem): boolean {
    if (item.historyType == HistoryType.UPDATE_HISTORY) {
      return true;
    }
    if (item.facilityId != userStore.loginUser.facilityId) {
      return true;
    }

    return false;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: WaiterProgressHistoriesTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter) && this.filterWriter(row, filter);
  }

  /**
   * ### 検索ワードによるフィルタリング
   */
  public filterSearchWords(row: WaiterProgressHistoriesTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundTitle: boolean = false;
    let foundText: boolean = false;
    let foundStatus: boolean = false;
    let foundHistory: boolean = false;

    for (const word of words) {
      if (row.title.indexOf(word) != -1) {
        foundTitle = true;
        break;
      }

      switch (row.columnType) {
        case ColumnType.TEXT: {
          const text: string = row.text as string;
          if (0 <= text.indexOf(word)) {
            foundText = true;
          }
          break;
        }
        case ColumnType.STATUS: {
          const beforeStatusName: string = this.convertStatusName(row.beforeStatus as ResidentStatus);
          if (0 <= beforeStatusName.indexOf(word)) {
            foundStatus = true;
          }
          const afterStatusName: string = this.convertStatusName(row.afterStatus as ResidentStatus);
          if (0 <= afterStatusName.indexOf(word)) {
            foundStatus = true;
          }
          break;
        }
        case ColumnType.HISTORY: {
          for (const history of row.updateHistories) {
            const historyWord: string = `${history.columnName}${history.beforeValue}${history.afterValue}`;
            if (0 <= historyWord.indexOf(word)) {
              foundHistory = true;
              break;
            }
          }
          break;
        }
        default: {
          foundTitle = false;
          foundStatus = false;
          foundHistory = false;
          break;
        }
      }

      if (foundText == true || foundStatus == true || foundHistory == true) {
        break;
      }
    }

    return foundTitle || foundText || foundStatus || foundHistory;
  }

  /**
   * ### 記載者によるフィルタリング
   */
  public filterWriter(item: WaiterProgressHistoriesTableItem, filter: FilterSetting): boolean {
    switch (filter.writer) {
      case WriterFilterOptionValue.ALL: {
        return true;
      }
      case WriterFilterOptionValue.MINE_FACILITY: {
        if (item.writerType == WriterType.FACILITY_USER && item.facilityId == userStore.loginUser.facilityId) {
          return true;
        }
        break;
      }
      case WriterFilterOptionValue.OTHER_FACILITY: {
        if (item.writerType == WriterType.FACILITY_USER && item.facilityId != userStore.loginUser.facilityId) {
          return true;
        }
        break;
      }
      case WriterFilterOptionValue.WAITER: {
        if (item.writerType == WriterType.WAITER) {
          return true;
        }
        break;
      }
    }
    return false;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(item: WaiterProgressHistoriesTableItem): void {
    this.$emit("onEdit", item);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(item: WaiterProgressHistoriesTableItem): void {
    this.$emit("onDelete", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface WaiterProgressHistoriesTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface WaiterProgressHistoriesTableItem extends WaiterProgressHistoriesGetModel {
  /** 表示種別 */
  columnType: ColumnType;
  /** 履歴 */
  updateHistories: Array<UpdateHistory>;
  /** 全て表示するか否か */
  showAllText: boolean;
}

export interface FilterSetting {
  searchWord: string;
  writer: WriterFilterOptionValue;
}

export enum ColumnType {
  UNKNOWN = "unnown",
  TEXT = "text",
  STATUS = "status",
  HISTORY = "history"
}

export enum WriterFilterOptionValue {
  ALL = "all",
  MINE_FACILITY = "mine",
  OTHER_FACILITY = "other",
  WAITER = "waiter"
}

export interface UpdateHistory {
  /** 項目のテンプレート要素のtype */
  type: TemplateType;
  /** 項目名 */
  columnName: string;

  /** 変更前値のCSS class */
  beforeClass: string | string[];
  /** 変更前値 */
  beforeValue: any;

  /** 変更後値のCSS class */
  afterClass: string | string[];
  /** 変更後値 */
  afterValue: any;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.waiter-progress-histories-table-component {
  .edit-btn,
  .delete-btn {
    width: 64px;
  }

  .progress-history-icon {
    @include svg-icon("../../../assets/waiter/progress-history.svg", $font-base-color, 24px, 24px);
  }
  .update-history-icon {
    @include svg-icon("../../../assets/waiter/update-history.svg", $font-base-color, 24px, 24px);
  }

  .no-input {
    color: $font-strong-color;
  }

  .checkbox {
    width: 20px;
    height: 20px;
  }
}
</style>
